import gsap, { Power2, Power3 } from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Basics } from '../_app/cuchillo/core/Basics';

export default class BGImage {
  static container;
  static _front;
  static _preloader;
  static _callback;
  static isFirstTime = true;
  static isReady = false;
  static isShow = false;
  static isBlocked = false;
  static _idTimerBlock = 0;
  static _waitSrc = null;
  static _actualSrc = null;

  static _blur = 0;
  static get blur() { return this._blur; }
  static set blur(__n) {
    console.log('IMG SET BLUR', this.container);
    this._blur = __n;
    this.container.style.setProperty('--blur', `${this._blur}px`);
  }

  static _scale = 0;
  static get scale() { return this._scale; }
  static set scale(__n) {
    this._scale = __n;
    this.container.style.setProperty('--scale', `${this._scale}`);
  }

  static init() {
    this.container = GetBy.id("BGImage");
    this._front = GetBy.selector("img", this.container)[0];
    this._preloader = GetBy.selector("img", this.container)[1];
  }

  static start(__call) {
    this._callback = __call;

    if (!this.isFirstTime) {
      const image = GetBy.selector("[data-img-init]")[0]?.dataset.imgInit;
      if (image) {
        this.play(image);
      } else {
        this.hide();
      }
    } else {
      this.isFirstTime = false;

      // Si ya está cargada (puede estar en caché del navegador)
      if (this._front.complete && this._front.naturalWidth > 0) {
        if (this._callback) {
          this._callback();
          this._callback = null;
        }
      } else {
        // Si no está cargada, esperamos al evento load
        this._front.addEventListener("load", () => {
          if (this._callback) this._callback();
          this._callback = null;
        }, { once: true });
      }
    }
  }

  static semihide() {
    this.isShow = false;
    gsap.to(this.container, { alpha: .2, duration: 2, ease: Power2.easeOut });
  }

  static play(__src) {
    if (this._actualSrc === __src) return false;

    if (this.isBlocked) {
      this._waitSrc = __src;
      return;
    }

    this.isBlocked = true;
    this._idTimerBlock = setTimeout(() => {
      this.isBlocked = false;
      if (this._waitSrc) {
        this.play(this._waitSrc);
        this._waitSrc = null;
      }
    }, 50);

    clearTimeout(this._timerOut);

    this.container.classList.add("--show");

    this._src = __src;
    this._actualSrc = __src;

    // if (this.isReady) { this._preloader.pause(); }

    this.isReady = false;

    // Handlers de precarga
    const onReady = () => {
      if (this.isReady) return;
      this.isReady = true;
      this.show();
      this.changeImage();

      if (this._callback) this._callback();
      this._callback = null;
    };

    this._preloader.onload = onReady;
    this._preloader.onerror = () => {
      console.warn("Error cargando imagen:", this._src);
    };

    // Lanzamos la carga
    this._preloader.setAttribute("src", this._src);

    // Si ya está cacheada y lista, disparamos manualmente
    if (this._preloader.complete && this._preloader.naturalWidth > 0) {
      onReady();
    } else if (typeof this._preloader.decode === "function") {
      this._preloader.decode().then(onReady).catch(() => { /* fallback a onload */ });
    }
  }

  static changeImage() {
    const temp = this._front;
    this._front = this._preloader;
    this._preloader = temp;

    this._front.classList.remove("image-preloader");
    this._preloader.classList.add("image-preloader");

    // Limpio el src del preloader para liberar memoria / cancelar descargas
    this._preloader.setAttribute("src", "");
  }

  static goBlur() {
    gsap.to(this, { blur: 20, scale: 1.5, duration: .8, ease: Power3.easeOut });
  }

  static goNormal() {
    gsap.to(this, { blur: 0, scale: 1, duration: .4, ease: Power2.easeOut });
  }

  static show() {
    if (this.isShow) return;

    this.isShow = true;
    gsap.killTweensOf(this.container);
    gsap.to(this.container, { alpha: 1, duration: .2, ease: Power2.easeOut });
  }

  static hide() {
    clearTimeout(this._idTimerBlock);
    this.isBlocked = false;

    if (Basics.tempValue === "cancel_hide") {
      Basics.tempValue = "";
      return;
    }

    this._timerOut = setTimeout(() => {
      clearTimeout(this._timerOut);

      this.isShow = false;
      gsap.killTweensOf(this.container);
      gsap.to(this.container, {
        alpha: 0,
        duration: .2,
        delay: 0,
        ease: Power2.easeOut,
        onComplete: () => {
          if (this.isReady) {
            // Para imágenes no hay pause(), solo limpiamos
            this._front.setAttribute("src", "");
            this._preloader.setAttribute("src", "");
          }
          this._actualSrc = null;
        }
      });
    }, 50);
  }

  static dispose() {
    this.hide();
  }
}


